import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';

const VARIANTS = {
  default: 'border-line-strong bg-surface text-fg hover:border-accent hover:text-accent',
  primary: 'border-transparent bg-accent text-accent-contrast hover:bg-accent-hover',
  ghost: 'border-transparent bg-transparent text-fg-secondary hover:bg-hover hover:text-fg',
  /** On the band. */
  band: 'border-transparent bg-transparent text-band-fg-secondary hover:bg-band-raised hover:text-band-fg',
} as const;

const SIZES = {
  sm: 'h-7 px-2.5 text-xs',
  md: 'h-9 px-4 text-[13px]',
  lg: 'h-10 px-5 text-sm',
  icon: 'size-9 px-0',
} as const;

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof VARIANTS;
  size?: keyof typeof SIZES;
  icon?: ReactNode;
}

export function Button({ variant = 'default', size = 'md', icon, className, type = 'button', children, ...rest }: ButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        'inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-full border font-medium transition-colors',
        'disabled:cursor-default disabled:opacity-55',
        VARIANTS[variant],
        SIZES[size],
        className,
      )}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
}
